export default __webpack_public_path__ + "static/media/Skull Gate Gauntlets.92aee5cd.jpg";